export default "__VITE_ASSET__Ch99hw0Q__"